// src/pages/HelpPage.js
import React from 'react';
import { FaWhatsapp, FaFacebookMessenger } from 'react-icons/fa';

export default function HelpPage() {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
      <h1 style={{ marginBottom: '30px', color: 'var(--primary)' }}>Ndihmë</h1>
      
      <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '8px', textAlign: 'center' }}>
        <p style={{ fontSize: '18px', marginBottom: '30px' }}>
          Për çdo pyetje ose ndihmë, mund të na kontaktoni përmes:
        </p>
        
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          {/* WhatsApp */}
          <a 
            href="https://wa.me/37744304200" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: '#25D366',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            <FaWhatsapp size={24} /> WhatsApp
          </a>
          
          {/* Facebook Messenger */}
          <a 
            href="https://m.me/61584142693044" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: '#0084ff',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            <FaFacebookMessenger size={24} /> Messenger
          </a>
        </div>
      </div>
    </div>
  );
}